export default "__VITE_PUBLIC_ASSET__0a403b4a__"